import { supabase } from '@/integrations/supabase/client';
import { AuthCredentials } from '@/types/auth';

export const getUserByUsername = async (username: string) => {
    const { data, error } = await supabase.rpc('get_user_by_username', {
      search_username: username,
    });

    if (error) {
      console.error('Error looking up user by username', error);
      return null;
    }
    return data;
}

export const signInWithPassword = async (credentials: AuthCredentials) => {
    const result = await supabase.auth.signInWithPassword(credentials);
    if (result.error || !result.data?.user) {
      return result;
    }
    // Fetch profile
    const { data: profile, error: profileError } = await supabase
      .from('profiles')
      .select('is_employee, is_approved')
      .eq('id', result.data.user.id)
      .maybeSingle();
    if (profileError || !profile) {
      await supabase.auth.signOut();
      return {
        ...result,
        error: { message: 'Could not fetch user profile. Please contact support.' }
      };
    }
    if (!profile.is_employee || !profile.is_approved) {
      await supabase.auth.signOut();
      return {
        ...result,
        error: { message: 'Your account is not active. Please contact an administrator.' }
      };
    }
    return result;
}

export const signUpNewUser = async (credentials: AuthCredentials & { username: string }) => {
    return await supabase.auth.signUp({
        email: credentials.email,
        password: credentials.password,
        options: {
            data: {
                username: credentials.username,
                is_employee: true,
                is_admin: false
            },
        }
    });
}

export const signOut = async () => {
    return await supabase.auth.signOut();
}

export const handleSystemAdminAuth = async () => {
    // First, try to create the system admin account
    const { data, error } = await supabase.auth.signUp({
      email: 'astratechdevs@example.com',
      password: 'Atd42120657@A',
      options: {
        data: {
          username: 'astratechdevs',
          isAdmin: true,
        }
      }
    });

    if (error) {
      if (error.message.includes('already registered')) {
        // If account exists, try to sign in with it
        const { error: loginError } = await supabase.auth.signInWithPassword({
          email: 'astratechdevs@example.com',
          password: 'Atd42120657@A',
        });

        if (loginError) {
          throw new Error(`Failed to access system admin account: ${loginError.message}`);
        }
        return { message: "System admin login successful" };
      } else {
        throw new Error(`Failed to create system admin account: ${error.message}`);
      }
    } else if (data.user) {
        return { message: "System admin account created successfully!" };
    }
    // Default return if no other condition is met
    return { message: "System admin auth process completed." };
}; 